/**
 * Presentation for a live validation checklist. The rules themselves live in
 * `@wlb/shared/utils/validation`; this only renders whatever a caller resolved,
 * so the password and name checklists stay visually identical.
 */
export interface CriteriaItem {
  key: string;
  label: string;
  met: boolean;
}

interface CriteriaListProps {
  items: readonly CriteriaItem[];
  /** Names the list for assistive technology. */
  label: string;
  /** Announced after each item so its state is not conveyed by colour alone. */
  metLabel: string;
  notMetLabel: string;
  id?: string;
}

export function CriteriaList({ items, label, metLabel, notMetLabel, id }: CriteriaListProps) {
  return (
    <ul className="criteria-list" id={id} aria-label={label}>
      {items.map(item => (
        <li
          key={item.key}
          className={`criteria-list__item${item.met ? ' criteria-list__item--met' : ''}`}
        >
          <span className="criteria-list__mark" aria-hidden>
            {item.met ? '✓' : '•'}
          </span>
          {item.label}
          <span className="sr-only">{item.met ? metLabel : notMetLabel}</span>
        </li>
      ))}
    </ul>
  );
}
